import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [authToken, setauthToken] = useState(true);
  const [permissions, setPermissions] = useState([]); // Store permissions
  const navigate = useNavigate();

  const validateToken = async () => {
    const token = localStorage.getItem("authentication/token");
    const refreshToken = localStorage.getItem("authentication/refresh_token");
    let savedPermissions = [];

    //   may error kapag na tampered yung permissions nang other value
    // const savedPermissions = JSON.parse(
    //   localStorage.getItem("authentication/permissions") || "[]"
    // );
    // Safely parse and validate the permissions
    try {
      const rawPermissions = localStorage.getItem("authentication/permissions");
      const parsedPermissions = JSON.parse(rawPermissions);

      if (Array.isArray(parsedPermissions)) {
        savedPermissions = parsedPermissions;
      } else {
        console.warn("Invalid permissions format. Resetting to empty array.");
        localStorage.removeItem("authentication/permissions");
      }
    } catch (error) {
      console.error("Error parsing permissions:", error);
      localStorage.removeItem("authentication/permissions");
    }
    // Safely parse and validate the permissions

    if (!token) {
      setIsLoading(false);
      return false;
    }

    try {
      const response = await fetch(`${BASE_URL}/validate-token`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

        if (response.ok) {
        setauthToken(localStorage.getItem("authentication/token"));
        setPermissions(savedPermissions);
        setIsAuthenticated(true);
        navigate("/dashboard");
        return true;
      } else if (refreshToken) {
        await refreshAccessToken(refreshToken);
      } else {
        setIsAuthenticated(false);
        navigate("/login");
      }
    } catch (error) {
      console.error("Token validation failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshAccessToken = async (refreshToken) => {
    try {
      const response = await fetch(`${BASE_URL}/refresh-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });

      if (response.ok) {
        const result = await response.json();
       localStorage.setItem("isLoggedIn", "true");
       localStorage.setItem("authentication/token", result.access_token);
       localStorage.setItem("authentication/expire", result.expires_in);
       localStorage.setItem("authentication/scopes", result.scope);
       localStorage.setItem(
         "authentication/refresh_token",
         result.refresh_token
       );
       localStorage.setItem("authentication/token_type", result.token_type);
       localStorage.setItem(
         "authentication/permissions",
         JSON.stringify(result.permissions)
       );

          setauthToken(localStorage.getItem("authentication/token"));
        setPermissions(JSON.stringify(result.permissions));
        setIsAuthenticated(true);
        alert("Success refreshAccessToken, /dashboard");
        navigate("/dashboard");
      } else {
        localStorage.clear();
        setIsAuthenticated(false);
        navigate("/login");
        return false;
      }
    } catch (error) {
      alert("Failed to refresh token:", error);
      localStorage.clear();
      navigate("/login");
      return false;
    }
  };

  const hasPermission = (requiredPermission) => {
    return permissions.includes(requiredPermission); // Check if permission exists
  };

  useEffect(() => {
    validateToken();
  }, []);

  return (
    <AuthContext.Provider
          value={{
              isAuthenticated,
              isLoading,
              permissions,
              hasPermission,
              authToken 
          }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for using AuthContext
export const useAuth = () => {
  return useContext(AuthContext);
};
